/**
* 페이지 상단으로 자동 스크롤
*/
function scrollToEnd() {
    window.scroll({ top: 99999, behavior: "smooth" });
}

export default scrollToEnd;